import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { PointsActivity } from '@/models';

export enum PointEventType {
  PointsEarned = 'PointsEarned',
  PointsUsed = 'PointsUsed',
  OffersIssued = 'OffersIssued',
  Divider = 'Divider',
  PointsExpired = 'PointsExpired',
  NoActivity = 'NoActivity',
}

@Component({
  name: 'CmgPointsHistoryCell',
})
export default class CmgPointsHistoryCell extends Vue {
  @Prop({ required: true, type: Object })
  activity!: PointsActivity;

  get activityDate(): string {
    return this.activity.activityDate.toLocaleString('default', { month: 'long',year: 'numeric' }).toUpperCase();
  }
  
  get endDate(): string {
    return this.activity.endDate?.toLocaleString('default', { month: 'long', year: 'numeric' }).toUpperCase() ?? '';
  }

  get pepperBadge(): string {
    return this.$appStore.state.cms.images.icons.pepperBadge.default;
  }

  get badgeUrl(): string {
    return this.activity.assets?.find(asset => asset.clientType === 'web')?.url ?? this.pepperBadge;
  }

  get activityPoints(): number {
    const deductions = [ PointEventType.OffersIssued, PointEventType.PointsUsed, PointEventType.PointsExpired ];
    
    return deductions.includes(this.activity.activityType as PointEventType)
      ? -(this.activity.activityPoints || 0)
      : this.activity.activityPoints || 0;
  }

  get formattedActivityPoints(): number {
    return Math.abs(this.activityPoints);
  }

  get details(): string {
    if (this.activity.activitySubTitle) {
      return this.activity.activitySubTitle;
    }

    return '';
  }

  get isNoActivity(): boolean {
    return this.activity.activityType === PointEventType.NoActivity;
  }

  get isMonthDivider(): boolean {
    return this.activity.activityType === PointEventType.Divider;
  }

  get formattedActivityDate(): string {
    return this.activity.activityDate.toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' });
  }
}
